import {ChildEntity, Column} from "typeorm";
import {Incident} from "@/modules/match/entity/Incident";
import GoalIncidentComponent from '@/modules/match/components/GoalIncident.vue';
import GoalIncidentLiveComponent from "@/modules/match/components/live-incident/GoalIncident.vue";
import {Component, ShallowRef} from "vue";

@ChildEntity()
export class GoalIncident extends Incident {
  @Column({type: 'boolean'})
  ownGoal = false;

  @Column({type: 'boolean'})
  penalty = false;

  get component(): ShallowRef<Component> {
    return shallowRef(GoalIncidentComponent);
  }

  get liveComponent(): ShallowRef<Component> {
    return shallowRef(GoalIncidentLiveComponent);
  }
}
